import { AfterViewInit, Directive, ElementRef, input, OnDestroy, output, signal } from '@angular/core';

@Directive({
  selector: '[componentScrollObserver]',
  standalone: true
})
export class ScrollObserverDirective implements AfterViewInit, OnDestroy {
  public readonly scrollObserverId = input.required<string>();
  public readonly observeScrollOnce = input(false);
  public readonly onScrolledBottom = output<void>();
  public readonly isFullyScrolledBottom = signal(false);

  private observer?: IntersectionObserver;
  private hasEmitted = false;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    if (!this.el.nativeElement) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        const elRect = entry.boundingClientRect;
        const intersection = entry.intersectionRect;

        const bottomVisible = intersection.bottom >= elRect.bottom - 1;
        this.isFullyScrolledBottom.set(bottomVisible);

        if (this.observeScrollOnce() && bottomVisible && !this.hasEmitted) {
          this.hasEmitted = true;
          this.onScrolledBottom.emit();
          this.observer?.disconnect();
        }
      },
      { threshold: this.generateEvenlySpacedArray(100) }
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  private generateEvenlySpacedArray(count: number, start = 0, end = 1) {
    if (count <= 1) return [start];
    const step = (end - start) / (count - 1);
    return Array.from({ length: count }, (_, i) => start + step * i);
  }
}
